import {fromJS} from 'immutable';

export const pinResetStarted = (state, action) => {
    return state.setIn(
        ['workOrderDetails', action.orderId, 'pinReset', action.request && action.request.pinType],
        fromJS({
            loading: true,
            loadingFinished: false,
            isError: false,
            error: null
        })
    );
};

export const pinResetFinished = (state, action) => {
    return state.setIn(
        ['workOrderDetails', action.orderId, 'pinReset', action.pinType],
        fromJS({
            loading: false,
            loadingFinished: true,
            isError: false,
            error: null,
            data: action.response
        })
    );
};

export const pinResetFailed = (state, action) => {
    return state.setIn(
        ['workOrderDetails', action.orderId, 'pinReset', action.pinType],
        fromJS({
            loading: false,
            loadingFinished: false,
            isError: true,
            error: action.error
        })
    );
};

export const pinResetReset = (state, action) => {
    if (action.pinTypes && action.pinTypes.length > 0) {
        action.pinTypes.forEach(pinType => {
            state = state.removeIn([
                'workOrderDetails',
                action.orderId,
                'pinReset',
                pinType
            ]);
        });
    }
    
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/pinReset.js